import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { erpApi } from '@/shared/axios/erp-api';
import { urlBackend } from '@/shared/constants';
import { useUiStore } from '@/store/ui';
import { getUrlParamsFetch, handleAxiosError } from '@/shared';
import { AlertSeverityEnum, Egreso, IEgresoPagingRes, UseMutationsParams } from '@/shared/interfaces';

const { get, post, put} = erpApi();


export const useFetchEgreso = (params?: GetEgresosParams) => {
  return useQuery({
    queryKey: ['egresos', ...Object.values(params || {})],
    queryFn: async () => {
      return GetEgresos(params);
    },
  });
};
export const useGetPedido = (id: string) => {
  return useQuery({
    queryKey: ['-egresos', id],
    queryFn: async () => {
      return getEgreso(id);
    },
  });
};
  export const useCreateEgresos = ({
    navigate,
  
    enableRedirect = true,
    returnUrl,
  
    returnErrorUrl,
    enableErrorRedirect = false,
    customMessageErrorAlert,
  
    enableSuccessAlert = true,
    customSuccessMessage,
  }: UseMutationsParams) => {
    const queryClient = useQueryClient();
    const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
    const setAlert = useUiStore.getState().setAlert;
  
    return useMutation({
      mutationFn: createEgreso,
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['egreso'] });
  
        enableRedirect && navigate && returnUrl && navigate(returnUrl);
  
        enableSuccessAlert &&
          setAlert &&
          setAlert(
            true,
            customSuccessMessage ?? ' egreso creada correctamente',
            AlertSeverityEnum.success
          );
      },
      onError: error => {
        enableErrorRedirect &&
          navigate &&
          returnUrl &&
          navigate(returnErrorUrl ?? (returnUrl || ''));
  
        handleAxiosError(error, customMessageErrorAlert);
      },
      onSettled: () => {
        setIsGlobalLoading(false);
      },
    });
  };
  export const useUpdateEgresos = ({
    navigate,
  
    enableRedirect = true,
    returnUrl,
  
    returnErrorUrl,
    enableErrorRedirect = false,
    customMessageErrorAlert,
  
    enableSuccessAlert = true,
    customSuccessMessage,
  }: UseMutationsParams) => {
    const queryClient = useQueryClient();
    const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
    const setAlert = useUiStore.getState().setAlert;
  
    return useMutation({
      mutationFn: updateEgreso,
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['egreso'] });
        enableRedirect && navigate && returnUrl && navigate(returnUrl);
  
        enableSuccessAlert &&
          setAlert &&
          setAlert(
            true,
            customSuccessMessage ?? ' egreso actualizada correctamente',
            AlertSeverityEnum.success
          );
      },
      onError: error => {
        enableErrorRedirect &&
          navigate &&
          returnUrl &&
          navigate(returnErrorUrl ?? (returnUrl || ''));
  
        handleAxiosError(error, customMessageErrorAlert);
      },
      onSettled: () => {
        setIsGlobalLoading(false);
      },
    });
  };
  export const useRemoveEgresos = () => {
    const queryClient = useQueryClient();
    const setConfirmDialogIsOpen = useUiStore.getState().setConfirmDialogIsOpen;
    return useMutation({
      mutationFn: deleteEgreso,
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['egreso'] });
      },
      onSettled: () => {
        setConfirmDialogIsOpen(false);
      },
      onError: (error) => {
        handleAxiosError(error);
      },
    });
  };
  ///* axios
  export type GetEgresosParams = {
    page?: number;
    page_size?: number;
    nombre?: string;
    numero_referencia?: string;
    solicitud_egreso?:string;
    unidad_trasporte?:string;
    estado?: string;
    fecha_after?: string;
    fecha_before?: string;
  };
  
  export type CreateEgresosParams = Omit<Egreso, 'id_egreso_inventario'>;
  export type UpdateEgresosParams = {
    id:string;
    data: CreateEgresosParams;
  };
  

  export const GetEgresos = async (params?:GetEgresosParams) => {
    const queryParams = getUrlParamsFetch({ ...params });
  
    return get<IEgresoPagingRes>(
      `${urlBackend}api/v1/egreso-inventario/?${queryParams}`,
      true
    );
  };
  export const getEgreso = async (id: string) => {
    try{
      return await get<Egreso>(`${urlBackend}api/egreso-inventario/${id}/`, true);
    }
    catch(error){
      return handleAxiosError(error);
    }
  };
  
  export const createEgreso = async (data: CreateEgresosParams) => {
    const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  setIsGlobalLoading(true);

  return post<Egreso>(`${urlBackend}api/v1/egreso-inventario/`, data, true);
  };
  
  export const updateEgreso = async ({ id, data }: UpdateEgresosParams) => {
    const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  setIsGlobalLoading(true);
  return put<Egreso>(`${urlBackend}api/v1/egreso-inventario/${id}/`, data, true);
  };
  
  export const deleteEgreso = async ({id,data}:UpdateEgresosParams) => {
    const setAlert = useUiStore.getState().setAlert;
    const res = await put<Egreso>(`${urlBackend}api/v1/egreso-inventario/${id}/`, data, true);
    setAlert(true, res.message, res.status);
    return res;
  };